export enum ContextTypeKeys {
    WORKSPACE_ID_UPDATED = 'context/WORKSPACE_ID_UPDATED',
    CONTENT_ITEM_ID_UPDATED = 'context/CONTENT_ITEM_ID_UPDATED',
    CONTENT_REVISION_ID_UPDATED = 'context/CONTENT_REVISION_ID_UPDATED',
    ITEM_BANK_ID_UPDATED = 'context/ITEM_BANK_ID_UPDATED',
}

export enum EditorMode {
    EDIT_MODE = 'editMode',
    PREVIEW_MODE = 'previewMode',
    ADD_TO_QUESTION_MODE = 'addToQuestionMode',
    USED_FOR_MARKING_MODE = 'usedForMarkingMode',
    STUDENT_MODE = 'studentMode',
}

export type ContextUrlSearchStringObject = {
    workspaceId?: string;
    contentItemId?: number;
    assessmentRunId?: number;
    contentRevisionId?: number;
    itemBankId?: number;
    enableAiAssistedMarking?: boolean;
}
